import * as _ from "lodash";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { FlatMultiSelect } from "@/components";
import { Map } from "@/utils";

const Flag = ({ lights, persistLights, mapSettings }) => {
    const _hasSameValue = () =>
        !!_.reduce(lights, (result, light) =>
            _.isEqual(
                light.selectedFlags.sort(),
                lights[0].selectedFlags.sort(),
            ),
        );

    const onSelectFlag = (flag) => {
        const sameValue = _hasSameValue();
        const selectedFlags = sameValue ? lights[0].selectedFlags : [];
        const identity = ["value", flag.value];
        let newFlags = selectedFlags;
        const hasFlag = _.some(selectedFlags, identity);
        if (!hasFlag) {
            newFlags = [...selectedFlags, flag];
        } else {
            _.remove(newFlags, identity);
        }
        _.each(lights, (light) => {
            light.selectedFlags = newFlags;
        });
        persistLights(lights);
    };

    const convertToOptions = (collection, group) => {
        const sameValue = _hasSameValue();
        const flags = sameValue ? lights[0].flags : [];
        return _.filter(collection, (flag) => flag.group === group).map(
            (flag) => ({
                key: flag.label,
                value: flag,
                icon: (
                    <div
                        className={flag.icon}
                        style={
                            flag.icon === "triangle"
                                ? { borderBottomColor: flag.color }
                                : { backgroundColor: flag.color }
                        }
                    />
                ),
                selected:
                    typeof flag.value === "function"
                        ? flag.value(lights)
                        : _.some(flags, (selectedFlag) => {
                              return (
                                  sameValue && flag.value === selectedFlag.value
                              );
                          }),
            }),
        );
    };

    const renderCriticalFlags = (collection) => {
        return (
            <FlatMultiSelect
                title="Critical Flags"
                options={convertToOptions(collection, "critical")}
                onSelect={onSelectFlag}
            />
        );
    };

    const renderOtherFlags = (collection) => {
        return (
            <FlatMultiSelect
                title="Other Flags"
                options={convertToOptions(collection, "other")}
                onSelect={onSelectFlag}
            />
        );
    };

    const renderSystemGeneratedFlags = (collection) => {
        return (
            <FlatMultiSelect
                disabled
                title="System Generated (Not Editable)"
                options={convertToOptions(collection, "system")}
            />
        );
    };

    const positioningType =
        !_.isEmpty(mapSettings.fixtureDetails) &&
        mapSettings.fixtureDetails.positioningType;
    let collection = [];
    switch (positioningType) {
        case "BLE":
            _.forEach(Map.Collections.flags, (f) => {
                if (f.value !== 16 && f.value !== 2) {
                    collection.push(f);
                }
            });
            break;
        case "VLC":
            _.forEach(Map.Collections.flags, (f) => {
                if (f.value !== 128 && f.value !== 32) {
                    collection.push(f);
                }
            });
            break;
        default:
            collection = Map.Collections.flags;
            break;
    }

    return (
        <div className="col tab flags">
            {renderCriticalFlags(collection)}
            {renderOtherFlags(collection)}
            {renderSystemGeneratedFlags(collection)}
        </div>
    );
};

Flag.propTypes = {
    lights: PropTypes.any,
    changeLights: PropTypes.func,
    persistLights: PropTypes.func,
    mapSettings: PropTypes.any,
};

const mapStateToProps = ({ map }) => ({
    mapSettings: map.general.settings,
});

export default connect(mapStateToProps, null)(Flag);
